import React, { useEffect, useState } from 'react';
import BModal from 'react-bootstrap/Modal';
import { Link, useHistory } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import useComparable from '~/commons/hooks/useComparable';
import PageHttp from '~/commons/components/PageHttp.jsx';
import ListPagination from '~/commons/components/ListPagination.jsx';
import ModalAnsConfirm from '../modals/ModalAnsConfirm.jsx';
import BtnLimit from '../btns/BtnLimit.jsx';
import BtnSort from '../btns/BtnSort.jsx';

import BorderBox from '../blocks/BorderBox.jsx';
import ReadingListItems from '../blocks/ReadingListItems.jsx';

const ReadingList = ({ assignmentId }) => {
  const [res, req, fetched = { total: 0 }] = useHttpStatus();

  const fetch = () => {
    req({
      url: `/api/quiz/assignments/missions/${assignmentId}`,
      params: {
        sort: { slot: 1 },
      },
    });
  };
  useEffect(() => {
    fetch();
  }, []);
  return (
    <PageHttp res={res} className="position-relative">
          {(rows) => (
            <>
              <div className="container-fluid no-gutters px-0">
                <div className="missions-bar position-absolute"></div>
                <BorderBox
                  name="missions-box"
                  left={{
                    width: '45px',
                    background: 'linear-gradient(180deg, #B1EAFF 0%, #78DBFF 100%)',
                  }}
                  right={{
                    width: '45px',
                    background: 'linear-gradient(180deg, #15C1FF 0%, #A8E2F7 100%)',
                  }}
                  top={{ height: '53px' }}
                  bottom={{ height: '53px' }}
                >
                  <ReadingListItems assigments={rows} />
                </BorderBox>
              </div>
            </>
          )}
    </PageHttp>
  );
};
export default ReadingList;
